module.exports = __webpack_public_path__ + "static/media/SpringVille_PH1_4.14962096.webp";